/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import { ImageAsset } from '@packages/common-ui/components/image';
import { FAQ_URL, MEDIA_STORAGE, POINTS_PORTAL_URL } from '@packages/common-ui/constants';
import { FarawayLogo } from '@packages/common-ui/components/icons/faraway';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import { GamesCarousel } from '@farawaygg/common';
import { useWindowScroll } from '@uidotdev/usehooks';
import { useBreakpoint } from '@packages/common-ui/hooks/use-breakpoint';
import { LotmRoutes } from '../Header/routes';
import * as S from './styled';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
type GameConfig = {
  image: string;
  href: string;
};
type CarouselConfig = {
  image: string;
  title: string;
  description: string;
};
type Config = {
  games: GameConfig[];
  firstCarousel: CarouselConfig[];
  secondCarousel: CarouselConfig[];
  thirdCarousel: CarouselConfig[];
};
const buttonInnerClassName = 'p-[20px] min-w-[220px] !text-[18px] tracking-[1.26px] !font-[700]';
export const LandingPage: NextPage = () => {
  const [thirdActiveSlide, setThirdActiveSlide] = useState(0);
  const [secondActiveSlide, setSecondActiveSlide] = useState(0);
  const [coordinate] = useWindowScroll();
  const isTablet = useBreakpoint('lg');
  const isDesc = useBreakpoint('2xl');
  const isSmalDesc = useBreakpoint('xl');
  const calcTraverseA = () => {
    let startPosition = 3600;
    let height = 2000;
    if (isTablet) {
      startPosition = 4500;
      height = 2500;
    }
    if (isSmalDesc) {
      height = 2800;
    }
    let traverse = startPosition - (coordinate.y || 0);
    if (traverse < -height) {
      traverse = -height;
    }
    if (traverse > height) {
      traverse = height;
    }
    return traverse;
  };
  const [carouselConfig, setCarouselConfig] = useState<Config>({
    games: [],
    firstCarousel: [],
    secondCarousel: [],
    thirdCarousel: []
  });
  const fetchConfig = async () => {
    let config = (await fetch(`${MEDIA_STORAGE}/main-landing/carousel-config.json`).then(response => response.json())) as Config;
    config = {
      ...config,
      games: config.games.map(item => ({
        ...item,
        image: `${MEDIA_STORAGE}/${item.image}`
      }))
    };
    setCarouselConfig(config);
  };
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    fetchConfig();
  }, []);
  return <div className="relative h-full min-h-screen bg-[#0F0E1C] overflow-hidden">
      <S.RobotBG />
      <S.CreaturesBG />
      <S.HeadingWrapper>
        <S.HeadingText css={S.BlackColor}>
          Fight. Farm.
          <br /> Reap the rewards.
        </S.HeadingText>
        <S.HeadingDesc variant="H5" css={[S.BlackColor, S.Chakra]}>
          Create the ultimate team to defeat the Shattered, harvest ingredients, craft mysterious
          items, and defend Paradis.
        </S.HeadingDesc>
        <Link href={LotmRoutes.camp} className="block w-fit m-auto relative z-10">
          <S.Button disabled innerClassName={buttonInnerClassName}><span css={{
            marginBottom: '-2px'
          }}>coming soon</span></S.Button>
        </Link>
      </S.HeadingWrapper>
      <div className="relative overflow-hidden">
        <S.LoopAnimationWrapper>
          <S.LineText>Fight. Farm. Reap the rewards.{' '}</S.LineText>
          <S.LineText>Fight. Farm. Reap the rewards.{' '}</S.LineText>
        </S.LoopAnimationWrapper>
      </div>
      <div className="relative">
        <S.GrayBlickCreature />
        <S.MachineWraper>
          <S.WhiteLabel>
            CREATURES OF PARADIS
          </S.WhiteLabel>
          <S.CreatureWrapper>
            <S.CreatureWrapperText>
              ASSEMBLE YOUR TEAM OF MARA AND KODAMARA TO DEFEAT THE SHATTERED
            </S.CreatureWrapperText>
          </S.CreatureWrapper>
        </S.MachineWraper>
        <S.CaruselFirst>
          {carouselConfig.firstCarousel.length > 0 && <Swiper loop autoplay={{
          delay: 6000,
          disableOnInteraction: false
        }} effect="coverflow" centeredSlides slidesPerView="auto" loopAddBlankSlides={false} loopAdditionalSlides={2} coverflowEffect={{
          rotate: 1,
          stretch: 130,
          depth: 500,
          modifier: -0.5,
          slideShadows: true
        }} modules={[EffectCoverflow, Autoplay]}>
              {[...carouselConfig.firstCarousel, ...carouselConfig.firstCarousel]?.map((item, index) => <SwiperSlide key={index}>
                    <S.C1Slide1 css={{
              backgroundImage: `url('${MEDIA_STORAGE}/${item.image}')`
            }} />
                  </SwiperSlide>)}
            </Swiper>}
        </S.CaruselFirst>
        <S.GetYourCreatureLink href="https://shop.faraway.com/lotm" target="_blank">
          <S.Button innerClassName={buttonInnerClassName} className="uppercase">
          <span css={{
            marginBottom: '-2px'
          }}>get your creature</span>
          </S.Button>
        </S.GetYourCreatureLink>
      </div>
      <S.DefendWrapper css={S.GreyBg}>
        <S.DefendRift>
          <S.BouncingAnimationWrapper className="flex-shrink-0">
            <S.DefRobotWrapper>
              <ImageAsset src="/assets/main-landing/paradis-img.webp" width="552px" height="552px" />
            </S.DefRobotWrapper>
          </S.BouncingAnimationWrapper>
          <S.DefendDescWrapper>
            <div>
              <S.BlackLabel className="m-auto md:mx-0 mb-[20px]">
                ALCHEMISTS OF PARADIS
              </S.BlackLabel>
              <S.DefendTitle>HARVEST & CRAFT</S.DefendTitle>
            </div>
            <S.DefendDescText css={S.Chakra}>
              Harvest ingredients from your Paradis land to craft potions and boosters to use in
              battle.
            </S.DefendDescText>
            <Link href={LotmRoutes.camp} className="block w-fit m-auto md:m-0">
              <S.Button disabled innerClassName={buttonInnerClassName}><span css={{
                marginBottom: '-2px'
              }}>coming soon</span></S.Button>
            </Link>
          </S.DefendDescWrapper>
        </S.DefendRift>
      </S.DefendWrapper>

      <S.KaijuWrapper>
        <div className="m-auto max-w-[1024px]">
          <S.KaijuTitleWrapper>
            <S.DefendersLabel>DEFENDERS OF paradis</S.DefendersLabel>
            <S.KaijuTitle>Defeat the SHATTERED</S.KaijuTitle>
          </S.KaijuTitleWrapper>
          <S.KaijuDescription>
            <S.KaijuDescriptionText css={S.Chakra}>
              Form team synergies to defeat the Shattered and earn mysterious rewards. Defend
              Paradis and discover the origins of the Primara.
            </S.KaijuDescriptionText>
            <Link href={LotmRoutes.camp} className="block w-fit m-auto md:m-0">
              <S.Button disabled innerClassName={buttonInnerClassName}><span css={{
                marginBottom: '-2px'
              }}>coming soon</span></S.Button>
            </Link>
          </S.KaijuDescription>
        </div>
      </S.KaijuWrapper>
      <S.GameSection>
        <S.GameSectionTitleWrapper>
          <S.GameSectionTitle css={S.BlackColor}>
            defenders of a growing universe
          </S.GameSectionTitle>
          <S.GameSectionDesc css={[S.BlackColor, S.Chakra]}>
            Travel to other universes and use your Legends of the Mara creatures in new and
            unexpected ways
          </S.GameSectionDesc>
        </S.GameSectionTitleWrapper>
        {carouselConfig.games.length > 0 && <GamesCarousel games={carouselConfig.games} />}
      </S.GameSection>
      <S.YourHVMTLWrapper>
        <S.YourHVMTL>
          <S.YourHVMTLLeftWrapper>
            <S.YourHVMTLLeft>
              <S.TextM className="text-center md:text-left uppercase" css={S.BlackColor}>
                AscenD your creatures
              </S.TextM>
              <S.YourHVMTLDesc css={[S.BlackColor, S.Chakra]}>
                Craft ascension materials to complete recipes to ascend your Mara or Kodamara and
                unlock new benefits and abilities inside and outside of the game
              </S.YourHVMTLDesc>
              <Link href={POINTS_PORTAL_URL} className="m-auto md:m-0 relative z-20" target="_blank">
                <S.Button innerClassName={buttonInnerClassName}><span css={{
                  marginBottom: '-2px'
                }}>Go to Points Portal</span></S.Button>
              </Link>
            </S.YourHVMTLLeft>
          </S.YourHVMTLLeftWrapper>
          <S.YourHVMTRight>
            <S.AscMaterial1 traverse={calcTraverseA()} />
            <S.AscMaterial2 traverse={-calcTraverseA()} />
          </S.YourHVMTRight>
        </S.YourHVMTL>
      </S.YourHVMTLWrapper>
      <S.ShadowWrapper>
        <S.CreateYourSuperTeamWrapper>
          <div className="relative xl:pb-[175px] lg:pb-[125px] pb-[60px]">
            <S.GrayBlick />
            <S.LoopAnimationWrapper>
              <S.LineText>create your super team{' '}</S.LineText>
              <S.LineText>create your super team{' '}</S.LineText>
            </S.LoopAnimationWrapper>
            <S.BouncingAnimationWrapper>
              <S.CardWrapper>
                <S.CardContent>
                  <S.RobotCard1 />
                  <S.RobotCard2 />
                  <S.RobotCard3 />
                  <S.RobotCard4 />
                  <S.RobotCard5 />
                </S.CardContent>
              </S.CardWrapper>
            </S.BouncingAnimationWrapper>
            <S.CreateYourTeamWrapper>
              <S.CreateYourTeamText css={S.Chakra}>
                Create your ultimate Legends of the Mara team and strategize in order to defeat the
                Shattered and defend Paradis.
              </S.CreateYourTeamText>
              <Link href="https://shop.faraway.com/lotm" target="_blank" className="block w-fit m-auto">
                <S.Button innerClassName={buttonInnerClassName} className="relative z-10">
                <span css={{
                  marginBottom: '-2px'
                }}>Go to SHOP</span>
                </S.Button>
              </Link>
            </S.CreateYourTeamWrapper>
          </div>
        </S.CreateYourSuperTeamWrapper>
      </S.ShadowWrapper>
      <S.CaseWrapper>
        <S.TextM className="mb-[30px] sm:w-fit w-[189px] m-auto text-center sm:text-left uppercase" css={S.BlackColor}>
          LOTM Keys & CHESTS
        </S.TextM>
        <S.CaruselSecond>
          {carouselConfig.secondCarousel.length > 0 && <Swiper loop autoplay={{
          delay: 6000,
          disableOnInteraction: false
        }} effect="coverflow" centeredSlides loopAddBlankSlides={false} loopAdditionalSlides={carouselConfig.secondCarousel.length} slidesPerView={2} coverflowEffect={{
          rotate: 1,
          stretch: 0,
          depth: 500,
          modifier: -0.7,
          slideShadows: false
        }} breakpoints={{
          460: {
            slidesPerView: 3
          },
          769: {
            slidesPerView: 5,
            coverflowEffect: {
              rotate: 1,
              stretch: 130,
              depth: 500,
              modifier: -0.5,
              slideShadows: false
            }
          }
        }} modules={[EffectCoverflow, Autoplay]} onSlideChange={swiper => {
          setSecondActiveSlide(swiper.realIndex % carouselConfig.secondCarousel.length);
        }} onTransitionStart={swiper => {
          setSecondActiveSlide((swiper as SwiperClass).realIndex % carouselConfig.secondCarousel.length);
        }}>
              {[...carouselConfig.secondCarousel, ...carouselConfig.secondCarousel, ...carouselConfig.secondCarousel]?.map((item, index) => <SwiperSlide key={index}>
                  <S.C1Slide1 css={{
              backgroundImage: `url('${MEDIA_STORAGE}/${item.image}')`
            }} />
                </SwiperSlide>)}
            </Swiper>}
          <S.CaseName css={S.WhiteColor}>
            {carouselConfig.secondCarousel?.[secondActiveSlide]?.title}
          </S.CaseName>
          <S.CaseDesc css={[S.BlackColor, S.Chakra]}>
            {carouselConfig.secondCarousel?.[secondActiveSlide]?.description}
          </S.CaseDesc>
        </S.CaruselSecond>
        <Link href={POINTS_PORTAL_URL} className="block w-fit m-auto" target="_blank">
          <S.Button innerClassName={buttonInnerClassName}><span css={{
            marginBottom: '-2px'
          }}>Go to Points Portal</span></S.Button>
        </Link>
      </S.CaseWrapper>

      <div className="relative overflow-hidden">
        <S.LoopAnimationWrapper>
          <S.LineText>defeat the Shattered</S.LineText>
          <S.LineText>defeat the Shattered</S.LineText>
        </S.LoopAnimationWrapper>
      </div>
      <S.DefKaijuWrapper>
        <S.DefKaijuContent>
          <S.CaruselThird>
            {carouselConfig.thirdCarousel.length > 0 && <Swiper loop autoplay={{
            delay: 12000,
            disableOnInteraction: false
          }} effect="coverflow" centeredSlides loopAddBlankSlides={false} loopAdditionalSlides={carouselConfig.thirdCarousel.length} coverflowEffect={{
            rotate: 0,
            stretch: -50,
            depth: 500,
            modifier: -0.8,
            slideShadows: false
          }} slidesPerView={2} breakpoints={{
            460: {
              slidesPerView: 3
            },
            768: {
              slidesPerView: 4
            }
          }} modules={[EffectCoverflow, Autoplay]} onSlideChange={swiper => {
            setThirdActiveSlide(swiper.realIndex % carouselConfig.thirdCarousel.length);
          }} onTransitionStart={swiper => {
            setThirdActiveSlide((swiper as SwiperClass).realIndex % carouselConfig.thirdCarousel.length);
          }}>
                {[...carouselConfig.thirdCarousel, ...carouselConfig.thirdCarousel, ...carouselConfig.thirdCarousel]?.map((item, index) => <SwiperSlide key={index}>
                    <S.C1Slide1 css={{
                backgroundImage: `url('${MEDIA_STORAGE}/${item.image}')`
              }} />
                  </SwiperSlide>)}
              </Swiper>}
          </S.CaruselThird>

          <S.DefKaijuName css={S.BlackColor} className="m-auto mt-[23px] sm:mt-[30px] w-fit">
            {carouselConfig.thirdCarousel?.[thirdActiveSlide]?.title}
          </S.DefKaijuName>
          <S.CaruselThirdDesc css={[S.BlackColor, S.Chakra]}>
            {carouselConfig.thirdCarousel?.[thirdActiveSlide]?.description}
          </S.CaruselThirdDesc>
          <Link href={LotmRoutes.camp} className="block w-fit m-auto">
            <S.Button disabled innerClassName={buttonInnerClassName}><span css={{
              marginBottom: '-2px'
            }}>coming soon</span></S.Button>
          </Link>
        </S.DefKaijuContent>
      </S.DefKaijuWrapper>
      <S.FaqWrapper>
        <div className="max-w-[657px] text-center m-auto">
          <S.FaqTittle css={S.BlackColor}>most frequent questions</S.FaqTittle>
          <S.FaqText css={[S.BlackColor, S.Chakra]}>
            Find answers to popular questions to get started quickly.
          </S.FaqText>
        </div>
        <Link href={FAQ_URL} className="block w-fit m-auto" target="_blank">
          <S.Button innerClassName={buttonInnerClassName}><span css={{
            marginBottom: '-2px'
          }}>GO TO FAQ</span></S.Button>
        </Link>
      </S.FaqWrapper>
      <S.FooterWrapper>
        <S.Footer>
          <S.BouncingAnimationWrapper>
            <S.PinkRobot />
          </S.BouncingAnimationWrapper>
          <S.FooterContent>
            <Link className="block w-fit m-auto mb-[71px] sm:mb-[91px] pt-[49px]" href="https://faraway.com/" target="_blank" rel="noreferrer noopener">
              <span className="sr-only">Faraway</span>
              <FarawayLogo className="h-[23px]" />
            </Link>
            <div className="flex gap-[40px] flex-col sm:mb-[91px] mb-[61px]">
              <S.FooterLink href="https://twitter.com/farawaygg" target="_blank">
                <S.TextH3>X</S.TextH3>
              </S.FooterLink>
              <S.FooterLink href="https://discord.gg/faraway" target="_blank">
                <S.TextH3>Discord</S.TextH3>
              </S.FooterLink>
              <S.FooterLink href="https://faraway.com" target="_blank">
                <S.TextH3>Faraway Home</S.TextH3>
              </S.FooterLink>
            </div>
            <div className="flex lg:gap-[40px] gap-[13px] m-auto w-fit flex-col md:flex-row text-center">
              <S.SecondaryFooterLink href="https://faraway.com/terms" target="_blank">
                <S.TextH7 css={S.Chakra}>Terms of Service</S.TextH7>
              </S.SecondaryFooterLink>
              <S.SecondaryFooterLink href="https://faraway.com/privacy" target="_blank">
                <S.TextH7 css={S.Chakra}>Privacy Policy</S.TextH7>
              </S.SecondaryFooterLink>
              <S.SecondaryFooterLink href="https://faraway.com" target="_blank">
                <S.TextH7 css={S.Chakra}>© {new Date().getFullYear()} Faraway Inc</S.TextH7>
              </S.SecondaryFooterLink>
            </div>
          </S.FooterContent>
          <S.BouncingAnimationWrapper>
            <S.YellowRobot />
          </S.BouncingAnimationWrapper>
        </S.Footer>
      </S.FooterWrapper>
    </div>;
};